import { render, staticRenderFns } from "./ServiceCategoryEdit.vue?vue&type=template&id=239ce4b0&"
import script from "./ServiceCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports